import React from "react"
import { Draggable } from "@hello-pangea/dnd"
import { Link } from "react-router-dom"
import { CalendarDays, Clock3, ExternalLink } from "lucide-react"
import MemberAssignmentPicker from "./MemberAssignmentPicker"

const TaskColumn = ({ status, tasks, onOpenTask, provided, actionById, eventById, actionColor, groupId, members, onAssign }) => (
  <div className="group-task-column" ref={provided.innerRef} {...provided.droppableProps}>
    <h3>{status.replace("_", " ")} <span>{tasks.length}</span></h3>
    {tasks.length === 0 ? <div className="group-task-column-empty">Nothing here</div> : <div className="space-y-3">
      {tasks.map((task, index) => {
        const action = actionById[task.actionId]
        const calendarEvent = eventById[task.calendarEventId]
        return <Draggable key={String(task.id)} draggableId={String(task.id)} index={index}>{(drag, snapshot) => <article
          ref={drag.innerRef} {...drag.draggableProps} {...drag.dragHandleProps}
          className={`group-task-card ${snapshot.isDragging ? "is-dragging" : ""}`}
          style={{ ...drag.draggableProps.style, "--action-color": actionColor(task.actionId) }}
          onClick={() => onOpenTask(task)} tabIndex={0} role="button"
          onKeyDown={event => { if (event.key === "Enter" || event.key === " ") onOpenTask(task) }}>
          <div className="group-task-links">
            {action && <Link className="group-task-link" to={`/group-members/${groupId}?tab=actions&actionId=${action.id}`} onClick={event => event.stopPropagation()}><ExternalLink size={13} /> {action.title || action.actionStatement || `Action ${action.id}`}</Link>}
            {calendarEvent && <Link className="group-task-link" to={`/group-members/${groupId}?tab=calendar&calendarEventId=${calendarEvent.id}`} onClick={event => event.stopPropagation()}><CalendarDays size={13} /> {calendarEvent.title}</Link>}
          </div>
          <h4>{task.title}</h4>
          {task.description && <p>{task.description}</p>}
          <div className="group-task-card-meta"><span>{task.type}</span>{task.dueDate && <span><Clock3 className="h-3 w-3" /> {new Date(task.dueDate).toLocaleDateString()}</span>}</div>
          <MemberAssignmentPicker members={members} value={task.assignedMemberId} onAssign={memberId => onAssign(task, memberId)} />
        </article>}</Draggable>
      })}
    </div>}
    {provided.placeholder}
  </div>
)

export default TaskColumn
